module.exports = __webpack_public_path__ + "ASpecIllustration.jpg?7b4c7f588ebc7ce0c7a54767de2c5adc";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/ASpecIllustration.jpg
// module id = 436
// module chunks = 0